import { DropdownField, NumberField } from '@cian/components';
import { plural } from '@cian/utils/lib/shared/plural';
import * as React from 'react';
import { connect } from 'react-redux';

import { getDefaultTravelTimeForType } from '../../../../utils/underground';
import { FieldBlurificator } from '../../../../common/components/field_blurificator';
import { IAppState, Dispatch } from '../../../../common/state';
import { EMetroTravelType } from '../../../../json_query';
import { changeUndergroundTravelWithSearch } from '../../../state/underground_travel';
import { InlineBlock, InlineLabel, Row } from '../markup';

type NumberFieldBlurificator = new () => FieldBlurificator<number | undefined>;
const NumberFieldBlurificator = FieldBlurificator as NumberFieldBlurificator;

export interface IPublishPeriodProps {
  travelType: EMetroTravelType;
  travelTime: number | undefined;

  onUndergroundTravelChanged(travelType: EMetroTravelType, travelTime: number | undefined): void;
}

export const metro: React.StatelessComponent<IPublishPeriodProps> = props => {
  const travelTime = props.travelTime || getDefaultTravelTimeForType(props.travelType);

  return (
    <Row title="До метро">
      <InlineBlock>
        <DropdownField
          value={props.travelType}
          // tslint:disable-next-line:max-line-length
          onValueChange={(value: EMetroTravelType) =>
            props.onUndergroundTravelChanged(value, props.travelTime || getDefaultTravelTimeForType(value))
          }
          values={[
            { value: EMetroTravelType.Any, label: 'Неважно' },
            { value: EMetroTravelType.MapFoot, label: 'Пешком' },
            { value: EMetroTravelType.MapTransport, label: 'Транспортом' },
          ]}
        />
      </InlineBlock>
      {props.travelType !== EMetroTravelType.Any && (
        <InlineBlock>
          <InlineLabel>Не более:</InlineLabel>
          <InlineBlock>
            <NumberField
              disableFractional
              disableNegative
              inputStyle={{ width: '60px' }}
              value={travelTime}
              onValueChange={(value: number | undefined) => props.onUndergroundTravelChanged(props.travelType, value)}
            />
          </InlineBlock>
          <InlineLabel>{(travelTime && plural(travelTime, ['минута', 'минуты', 'минут'])) || 'минут'}</InlineLabel>
        </InlineBlock>
      )}
    </Row>
  );
};

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => {
    // tslint:disable-next-line:max-line-length
    const travelType =
      (state.filters.jsonQuery.only_foot && state.filters.jsonQuery.only_foot.value) || EMetroTravelType.Any;

    return {
      travelType,
      travelTime: state.filters.jsonQuery.foot_min && state.filters.jsonQuery.foot_min.value.lte,
    };
  },
  (dispatch: Dispatch) => ({
    onUndergroundTravelChanged: (travelType: EMetroTravelType, travelTime: number | undefined) => {
      dispatch(changeUndergroundTravelWithSearch(travelType, travelTime));
    },
  }),
)(metro);
